// Build Your Pack discount fix | black-standard-extra-wide-copy redirect moved to an
// inline <script> at the top of <head> in layout/theme.liquid — this bundle loads too
// late to avoid a flash of the duplicate product's page before redirecting.

// V_CC_PROD-CARD_11 | CLP - Product Card Cleanup (Winner: Var A - Mobile Only)
function clpProdCardInit() {
  // Trim size descriptors from product titles
  document.querySelectorAll(".product-card__title").forEach(function (titleEl) {
    var target = titleEl.querySelector("a") || titleEl;
    target.textContent = target.textContent
      .replace(/\s*-\s*\([^)]*\)\s*$|\s+\([^)]*\)\s*$/, "")
      .trim();
  });

  // Format review counts: "4,643 Reviews" → "(4.6K)", "100 Reviews" → "(100)"
  document.querySelectorAll(".review-count").forEach(function (el) {
    var match = el.textContent.match(/^([\d,]+)/);
    if (!match) return;
    var num = parseInt(match[1].replace(/,/g, ""), 10);
    if (num > 999) {
      var k = (num / 1000).toFixed(1).replace(/\.0$/, "");
      el.textContent = "(" + k + "K)";
    } else {
      el.textContent = "(" + num + ")";
    }
  });
}

// Auto-apply on mobile (winner)
document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 749) clpProdCardInit();
});

// Bug fix: Cart drawer upsell buttons don't work after Quick Add from collection page.
// When a product is added via a collection-page quick-buy-drawer popup, _onVariantAdded
// hides the popup with display:none but skips hide(), leaving isQuickBuyOpen=true.
// This blocks all subsequent QuickBuyDrawer.show() calls (including cart upsell buttons).
// Fix: call hide() on any open quick-buy-drawer outside the cart drawer on variant:add,
// which properly resets isQuickBuyOpen=false via QuickBuyDrawer.hide().
document.addEventListener("variant:add", function () {
  document.querySelectorAll("quick-buy-drawer[open]").forEach(function (drawer) {
    if (!drawer.closest("cart-drawer")) {
      drawer.hide();
    }
  });
});

function cartUpsellBlackInit() {
  // Use event delegation on document so listeners survive cart drawer re-renders
  var VARIANTS = {
    'XS (shoe size 4-7)': {
      'Standard Width': 62692395745651,
      'Extra Wide Width': 62692395778419
    },
    'SM/MD (shoe size 7-10)': {
      'Standard Width': 62692395811187,
      'Extra Wide Width': 62692395843955
    },
    'LG/XL (shoe size 10-13)': {
      'Standard Width': 62692395876723,
      'Extra Wide Width': 62692395909491
    }
  };

  var SIZE_DISPLAY = {
    'XS (shoe size 4-7)': 'XS (Shoe size 4-7)',
    'SM/MD (shoe size 7-10)': 'SM/MD (Shoe size 7-10)',
    'LG/XL (shoe size 10-13)': 'LG/XLD (Shoe size 10-13)'
  };

  var selectedSize = 'XS (shoe size 4-7)';
  var selectedWidth = 'Standard Width';

  function closeModal() {
    var modal = document.querySelector('.c-cart-upsell-modal');
    if (modal) modal.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('click', function(e) {
    // Open modal
    if (e.target.closest('.c-cart-upsell__cta')) {
      var modal = document.querySelector('.c-cart-upsell-modal');
      if (!modal) {
        // Modal missing from DOM (cart was partially re-rendered via quick-buy) — fetch and inject it
        fetch(window.location.pathname + '?sections=cart-drawer')
          .then(function(r) { return r.json(); })
          .then(function(sections) {
            if (!sections['cart-drawer']) return;
            var parser = new DOMParser();
            var newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');
            var newModal = newDoc.querySelector('.c-cart-upsell-modal');
            if (!newModal) return;
            document.querySelector('cart-drawer').appendChild(newModal);
            selectedSize = 'XS (shoe size 4-7)';
            selectedWidth = 'Standard Width';
            newModal.setAttribute('aria-hidden', 'false');
          });
        return;
      }
      // Reset state to match freshly-rendered HTML defaults
      selectedSize = 'XS (shoe size 4-7)';
      selectedWidth = 'Standard Width';
      modal.setAttribute('aria-hidden', 'false');
      return;
    }

    // Close modal
    if (e.target.closest('.c-cart-upsell-modal__close') || e.target.matches('.c-cart-upsell-modal__overlay')) {
      closeModal();
      return;
    }

    // Size selection
    var sizeBtn = e.target.closest('.c-cart-upsell-modal__size-btn');
    if (sizeBtn) {
      document.querySelectorAll('.c-cart-upsell-modal__size-btn').forEach(function(b) { b.classList.remove('is-active'); });
      sizeBtn.classList.add('is-active');
      selectedSize = sizeBtn.dataset.size;
      var sizeLabel = document.querySelector('.c-cart-upsell-modal__selected-size');
      if (sizeLabel) sizeLabel.textContent = SIZE_DISPLAY[selectedSize];
      return;
    }

    // Width selection
    var widthBtn = e.target.closest('.c-cart-upsell-modal__width-btn');
    if (widthBtn) {
      document.querySelectorAll('.c-cart-upsell-modal__width-btn').forEach(function(b) { b.classList.remove('is-active'); });
      widthBtn.classList.add('is-active');
      selectedWidth = widthBtn.dataset.width;
      var widthLabel = document.querySelector('.c-cart-upsell-modal__selected-width');
      if (widthLabel) widthLabel.textContent = widthBtn.dataset.width;
      return;
    }

    // Add to cart
    if (e.target.closest('.c-cart-upsell-modal__atc')) {
      var variantId = VARIANTS[selectedSize][selectedWidth];
      var atcBtn = document.querySelector('.c-cart-upsell-modal__atc');
      if (atcBtn.disabled) return;
      atcBtn.disabled = true;
      atcBtn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function(r) { return r.json(); })
        .then(function() {
          atcBtn.textContent = 'Added!';
          closeModal();
          // Refresh cart drawer via Section Rendering API — no page reload
          return fetch(window.location.pathname + '?sections=cart-drawer');
        })
        .then(function(r) { return r.json(); })
        .then(function(sections) {
          if (!sections['cart-drawer']) return;
          var parser = new DOMParser();
          var newDoc = parser.parseFromString(sections['cart-drawer'], 'text/html');

          // Swap line items so black sock appears in cart
          var newLineItems = newDoc.querySelector('.cart-drawer__line-items');
          var oldLineItems = document.querySelector('.cart-drawer__line-items');
          if (newLineItems && oldLineItems) oldLineItems.innerHTML = newLineItems.innerHTML;

          // Update cart total
          var newTotal = newDoc.querySelector('.c-cart-total-price-container');
          var oldTotal = document.querySelector('.c-cart-total-price-container');
          if (newTotal && oldTotal) oldTotal.innerHTML = newTotal.innerHTML;

          // Update cart count bubble
          var newCount = newDoc.querySelector('cart-count');
          document.querySelectorAll('cart-count').forEach(function(el) {
            if (newCount) el.textContent = newCount.textContent;
          });

          // Remove upsell + modal
          var upsell = document.querySelector('.c-cart-upsell');
          if (upsell) upsell.remove();
          var upsellModal = document.querySelector('.c-cart-upsell-modal');
          if (upsellModal) upsellModal.remove();

          // Inject the black-in-cart marker so :has() keeps recommendations hidden
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && !cartDrawer.querySelector('.c-site09-black-in-cart')) {
            var marker = document.createElement('span');
            marker.className = 'c-site09-black-in-cart';
            marker.hidden = true;
            cartDrawer.appendChild(marker);
          }
        })
        .catch(function() {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Cart';
        })
        .finally(function() {          // In case something goes wrong, re-enable the button and keep the modal open so the user can try again
          document.dispatchEvent(new CustomEvent("cart:refresh"))
        });
    }
  });
}

// Size Chart Modal
(function () {
  var IMAGES = {
    desktop: 'https://cdn.shopify.com/s/files/1/1102/3318/files/c-size-chart-pdp-varb-desktop.webp',
    mobile:  'https://cdn.shopify.com/s/files/1/1102/3318/files/c-size-chart-pdp-varb-mobile.webp'
  };

  new Image().src = IMAGES.desktop;
  new Image().src = IMAGES.mobile;

  var modal = document.createElement('div');
  modal.className = 'c-pdp14-modal';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-label', 'Size Guide');
  modal.innerHTML =
    '<div class="c-pdp14-modal__overlay"></div>' +
    '<div class="c-pdp14-modal__dialog">' +
      '<button class="c-pdp14-modal__close" aria-label="Close">×</button>' +
      '<p class="c-pdp14-modal__title">Size Guide</p>' +
      '<img class="c-pdp14-modal__img" src="" alt="Size Guide" />' +
    '</div>';
  document.body.appendChild(modal);

  var modalImg = modal.querySelector('.c-pdp14-modal__img');

  function openModal(src) {
    modalImg.src = src;
    modal.classList.add('is-open');
    document.body.classList.add('c-pdp14-modal-open');
  }

  function closeModal() {
    modal.classList.remove('is-open');
    document.body.classList.remove('c-pdp14-modal-open');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.c-size-guide-button');
    if (!btn) return;

    if (window.innerWidth > 749) {
      e.stopImmediatePropagation();
      openModal(IMAGES.desktop);
    } else {
      var drawerId = btn.getAttribute('aria-controls');
      var drawer = drawerId ? document.getElementById(drawerId) : null;
      if (drawer) {
        var prose = drawer.querySelector('.prose');
        if (prose && !prose.dataset.pdp14Injected) {
          prose.innerHTML = '<img src="' + IMAGES.mobile + '" alt="Size Guide" class="c-pdp14-drawer-img" />';
          prose.dataset.pdp14Injected = 'true';
        }
      }
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest('.c-pdp14-modal__close') || e.target.matches('.c-pdp14-modal__overlay')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });
}());

// V_CC_PDP_18 winner: Var A (Working Women infographic) always shown
document.addEventListener('variant:change', function () {
  document.querySelectorAll('.c-pdp18-vara-slide, .c-pdp18-vara-dot, .c-pdp18-vara-thumb').forEach(function (el) { el.hidden = false; });
});

// iOS Safari fix: strip broken sizes/srcset on product card images caused by nil section settings
// Safari 17+ (iOS 26+) refuses to load images when sizes contains division by zero or empty operand
(function () {
  function fixBrokenSizes() {
    document.querySelectorAll('.product-card__image').forEach(function (img) {
      var sizes = img.getAttribute('sizes');
      if (sizes && (sizes.indexOf('/ 0') !== -1 || sizes.indexOf('/  -') !== -1 || sizes.indexOf('/ -') !== -1)) {
        img.removeAttribute('sizes');
        img.removeAttribute('srcset');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixBrokenSizes);
  } else {
    fixBrokenSizes();
  }

  var observer = new MutationObserver(fixBrokenSizes);
  observer.observe(document.body, { childList: true, subtree: true });
}());

